<div class="container mt-4 mb-5">

  <div class="row mb-4 mt-5">
    <div class="col-12 mt-3">
      <div class="d-flex align-items-center justify-content-between">
          <h2 class="mb-1">
            @if (moduleDetails?.name) {
              {{ moduleDetails.name }}
            } @else {
              Manage Magic Insights Module
            }
          </h2>

          @if (availableModules !== null) {
            <mat-form-field appearance="outline">
                <mat-label>Change Module</mat-label>
                <mat-select [(value)]="dropDownSelectedModuleId" (selectionChange)="onModuleChange()">
                    @for (mod of availableModules; track $index) {
                        <mat-option value="{{mod.id}}">{{mod.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
          }
      </div>
    </div>
  </div>

  @if (availableModules === null) {
    <div class="d-flex justify-content-center my-5 py-5">
        <zint-loader size="xSmall"></zint-loader>
    </div>
  }

  @if (moduleDetails) {

    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <h6 class="text-muted text-uppercase small fw-bold">Total Answers Generated</h6>
            <h2 class="display-6 fw-bold highlighted my-2">{{ moduleDetails.answer_count || 0 }}</h2>
            <div class="small text-muted">Across all companies</div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <h6 class="text-muted text-uppercase small fw-bold">Last Activity</h6>
            @if (moduleDetails.last_answer_generated_at) {
              <h3 class="fw-bold text-dark my-2">{{ moduleDetails.last_answer_generated_at | date:'mediumDate' }}</h3>
              <div class="small text-muted">{{ moduleDetails.last_answer_generated_at | date:'shortTime' }}</div>
            } @else {
              <h3 class="fw-bold text-muted my-2">-</h3>
              <div class="small text-muted">No activity yet</div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">

      <div class="col-lg-8 mb-4 mb-lg-0">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white py-3">
            <h5 class="card-title mb-0">Recent Runs</h5>
          </div>
          <div class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th scope="col" class="ps-4">User</th>
                  <th scope="col">Last Answer Generated</th>
                  <th scope="col">Status</th>
                  <th scope="col">Progress</th>
                  <th scope="col" class="text-end pe-4">Credit Consumption</th>
                </tr>
              </thead>
              <tbody>
                @for (run of moduleDetails.recent_runs; track run) {
                  @if (run.user_email) {
                    <tr>
                      <td class="ps-4">
                        <div class="fw-bold text-dark">{{ run.user_email }}</div>
                      </td>
                      <td>
                        @if (run.last_answer_generated_at) {
                          {{ run.last_answer_generated_at | date:'MMM d, y, h:mm a' }}
                        } @else {
                          <span class="text-muted fst-italic">Unknown</span>
                        }
                      </td>
                      <td>
                        @if (run.finalised_at || run.count_of_questions_answered >= run.initial_quota_consumption) {
                          <span class="badge text-zint-dark-blue">Completed</span>
                        } @else {
                            @if (!run.count_of_questions_answered) {
                              <span class="badge highlighted">Queued</span>
                            } @else{
                                <span class="badge highlighted">Processing</span>
                            }

                        }
                      </td>
                      <td style="min-width: 170px">
                          <progress-bar [label]="" [denominatorLabel]="''" [numeratorLabel]="''" [usage]="run.count_of_questions_answered" [quota]="run.initial_quota_consumption"></progress-bar>
                      </td>
                      <td class="text-end pe-4">
                         @if (run.initial_quota_consumption !== null) {
                            {{ run.initial_quota_consumption }} estimated /
                         } @else {
                            -
                         }
                          @if (run.final_quota_consumption !== null) {
                            {{ run.final_quota_consumption }} actual
                         } @else {
                            -
                         }
                      </td>
                    </tr>
                  }
                }
                @if (!moduleDetails.recent_runs?.length) {
                  <tr>
                    <td colspan="4" class="text-center py-4 text-muted">No recent runs found.</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-header bg-white py-3">
            <h5 class="card-title mb-0">Configured Questions</h5>
          </div>
          <div class="card-body p-0 max-height-25vh">
            <ul class="list-group list-group-flush">
              @for (q of moduleDetails.questions; track q.id) {
                <li class="list-group-item p-3 border-0 border-bottom">
                  <div class="d-flex align-items-start">
                    <span class="badge bg-light text-dark border me-2 mt-1 mr-1">Q{{ $index + 1 }}</span>
                    <p class="mb-0 small text-secondary">{{ q.question }}</p>
                  </div>
                </li>
              }
              @if (!moduleDetails.questions?.length) {
                <li class="list-group-item p-4 text-center text-muted">
                  No questions configured for this module.
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <div class="card shadow-sm border-0">
          <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Module Notifications</h5>
          </div>

          <div class="card-body p-0" style="max-height: 300px; overflow-y: auto;">
             @if (loadingNotifications) {
                <div class="p-4 text-center">
                  <zint-loader size="xSmall"></zint-loader>
                </div>
             } @else {
               <table class="table table-hover align-middle mb-0">
                  <thead class="table-light sticky-top">
                    <tr>
                      <th scope="col" class="ps-4" style="width: 60%">Notification</th>
                      <th scope="col" class="text-end pe-4" style="width: 20%">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (notification of notifications; track notification.id) {
                      <tr>
                        <td class="ps-4">
                          <div class="fw-bold text-dark">{{ notification.title }}</div>
                        </td>
                        <td class="text-end pe-4 text-muted small">
                          {{ notification.createdAt | date:'mediumDate' }}
                        </td>
                      </tr>
                    }
                    @if (notifications.length === 0) {
                      <tr>
                        <td colspan="3" class="text-center py-4 text-muted">No recent notifications found.</td>
                      </tr>
                    }
                  </tbody>
               </table>
             }
          </div>
        </div>
      </div>
    </div>

    @if (this.isSuperuser && moduleDetails?.perms_access){
        <div class="row">
          <div class="col-md-12">
            <div class="card p-3 shadow-sm border-0">
              <div class="card-body">
                <zint-permissions-v2
                  [modelKey]="MODEL_KEY"
                  [objectId]="moduleId"
                  [accessType]="'view'"
                  [permissionLabel]="'Who Can View, Filter & Generate Answers and View Logs?'"
                  [allUsers]="organisationUsers"
                  [allTeams]="organisationTeams"
                  (onPermissionUpdated)="onPermissionChanged($event)">
                </zint-permissions-v2>
                  <div class="bg-grey-50 border-rounded-05 p-3 mt-4">
                    <div class="d-flex align-items-center">
                      <i class="fal fa-info-circle text-vivid-blue mr-3 font-size-1-5"></i>
                      <div class="text-grey-600 extra-details line-height-normal flex-1">
                        <span class="d-block mr-4">
                            Users still require Magic Insight Answer credits to generate answers. Manage these <a href="/manage-quota?type=Magic%20Insights%20Answer" target="_blank">here.</a>
                        </span>
                      </div>
                    </div>
                 </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <div class="card p-3 shadow-sm border-0">
              <div class="card-body">
                <zint-permissions-v2
                  [modelKey]="MODEL_KEY"
                  [objectId]="moduleId"
                  [accessType]="'edit'"
                  [permissionLabel]="'Who Can Write Questions?'"
                  [allUsers]="organisationUsers"
                  [allTeams]="organisationTeams"
                  (onPermissionUpdated)="onPermissionChanged($event)">
                </zint-permissions-v2>
              </div>
            </div>
          </div>
        </div>
    }

  }

@if (availableModules !== null && availableModules?.length === 0) {
    <div class="alert mt-3 shadow-sm d-flex align-items-center">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>
      <div>
        You do not have any modules available. Contact your superuser or the Customer Success team at Zint to gain access.
      </div>
    </div>
  }

</div>
